// Types
import { TYPES } from "../types/types.constants";

// Services
import { VirtualCredentialService } from '../../services';

// Actions
import { setErrorAction } from './app.action';

// Constans
import { APP_CONFIG } from '../../constants';

/**
 * Obtiene una lista de beneficios disponibles
 * @param {Object} data Información de la transacción
 * @param {Function} loading Referencia a función para mostrar el loading
 */
export const startListAvailableBenefitsAction = (data, loading) => {

    return async (dispatch) => {
        try {

            loading(true);

            let transaction;
            if(data.subscriberDni){
                transaction = data;
            }
            if(data.subscriberUserData){
            transaction = {
                subscriberUserDataIv: data.subscriberUserData.iv,
                subscriberUserDataContent: data.subscriberUserData.content
            }}
            
            const benefits = await VirtualCredentialService.listBenefit(transaction);

            if ( benefits.length === 0 ) { throw new Error(APP_CONFIG.PAGES.BENEFIT.messages.error.notFoundBenefits); }

            // Si tengo un beneficio, activo el beneficio y el flujo se irá al detalle            
            if (benefits.length === 1) {
                
                transaction = { ...data, benefitId: benefits[0].benefitId };
                dispatch(activatedBenefitAction(benefits[0]));
            }

            dispatch(listBenefitAction(benefits));
            
        } catch (error) {
            
            dispatch(setErrorAction(error));
        }
        finally {

            loading(false);
        }
    };
};

/**
 * Setea un beneficio a estado activo
 * @param {Object} benefit Beneficio para activar
 */
export const activatedBenefitAction = (benefit) => {

    return {

        type: TYPES.BENEFIT.ACTIVATED,
        payload: {
            ...benefit
        }
    };
};

/**
 * Setea el listado de beneficios
 * @param {Array Object} benefits Beneficios obtenidos
 */
export const listBenefitAction = (benefits) => {

    return {

        type: TYPES.BENEFIT.LIST,
        payload: {
            benefits
        }
    };
};

/**
 * Vuelve al estado inicial la información de los beneficios
 */
export const resetBenefitAction = () => {

    return {

        type: TYPES.BENEFIT.RESET_BENEFIT
    };
};